import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { forPhoneOnly } from 'src/config/mediaQueries'
import { Theme } from '@mui/material/styles'

export default createUseStyles({
  descriptionStyles: {
    ...typography['Lato Body 1'],
    marginBottom: 32,
    [forPhoneOnly]: {
      marginBottom: 24,
    },
    textAlign: 'center',
  },
  headingStyles: {
    marginBottom: '40px',
  },
  error: {
    marginBottom: 20,
  },
})

export const inputStyles = (theme: Theme) => ({
  width: 56,
  height: 56,
  ...typography['Lato H4'],
  color: theme.palette.grey['800'],
  background: '#FFFFFF',
  border: 'none',
  borderRadius: 8,
  marginRight: 17,
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
})

export const inputFocusStyle = (theme: Theme) => ({
  background: theme.palette.primary.light,
  border: `1px solid ${theme.palette.primary.main}`,
})
